'use client';

import React from 'react';
import { primaryNav, secondaryNav } from './nav-links';
import { Button } from '@/components/ui/button';
import useDialog from '@/lib/frontend/hooks/useDialog';
import { EllipsisVertical, Search, X } from 'lucide-react';
import { QlabHeaderIcon } from './qlab-header-icon';
import { motion, AnimatePresence } from 'motion/react';
import { slideInOut } from '@/lib/frontend/utils/animate';
import { defaultFilterTypes, ShowSearch } from '@/lib/frontend/store/actionCreators/SearchActions';
import { useAppStore } from '@/lib/frontend/store/hooks';
import { useRouter } from '@/lib/frontend/hooks/useAppRouter';

export const MobileNav = () => {
  const nav = useDialog();
  const router = useRouter();
  const store = useAppStore();
  const handleNavigate = (link: string) => {
    nav.hide();

    router.push(link);
  };

  return (
    <nav className="sm:hidden">
      <div className="flex flex-col">
        <div className="flex items-center justify-between w-full">
          <QlabHeaderIcon />

          <div className="flex gap-3">
            <Button
              variant="ghost"
              size="icon"
              className="h-14 w-14 [&_svg]:size-8 rounded-full"
              onClick={() =>
                ShowSearch(store, {
                  filterTypes: defaultFilterTypes,
                })
              }
            >
              <Search />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              className="h-14 w-14 [&_svg]:size-8"
              onClick={nav.toggle}
              aria-label="More"
            >
              {nav.open ? <X /> : <EllipsisVertical />}
            </Button>
          </div>
        </div>

        <AnimatePresence>
          {nav.open && (
            <motion.div {...slideInOut()} className="overflow-hidden">
              <div className="flex gap-5 items-start mt-5">
                <div className="flex-1 flex flex-col gap-1">
                  {primaryNav.map(([label, href]) => (
                    <div key={label}>
                      <a className="cursor-pointer" onClick={() => handleNavigate(href)}>
                        {label}
                      </a>
                    </div>
                  ))}
                </div>
                <div className="flex-1 flex flex-col gap-1">
                  {secondaryNav.map(([label, href]) => (
                    <div key={label}>
                      <a className="cursor-pointer" onClick={() => handleNavigate(href)}>
                        {label}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
};
